export default "__VITE_ASSET__Cn0QPeaE__"